import React from 'react';
import { PaymentSummaryProps } from '../../types/invoice.types';
import { Card } from '../ui/Card';

const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  totalInvoiced,
  invoiceCount,
  totalPaid,
  paidInvoiceCount,
  upcomingPayments,
  nextPaymentDays
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };

  return (
    <>
      <Card className="bg-white p-4 shadow-sm flex-1 min-w-64 card_content_padding">
        <h2 className="text-base font-semibold text-gray-700 mb-1 mt-2">Total Invoiced</h2>
        <p className="text-2xl font-bold text-gray-800 mb-1 mt-3">{formatCurrency(totalInvoiced)}</p>
        <p className="text-xs text-gray-500">{invoiceCount} invoices</p>
      </Card>

      <Card className="bg-white p-4 shadow-sm flex-1 min-w-64 card_content_padding">
        <h2 className="text-base font-semibold text-gray-700 mb-1 mt-2">Total Paid</h2>
        <p className="text-2xl font-bold text-gray-800 mb-1 mt-3">{formatCurrency(totalPaid)}</p>
        <p className="text-xs text-gray-500">{paidInvoiceCount} invoices</p>
      </Card>

      <Card className="bg-white p-4 shadow-sm flex-1 min-w-64 card_content_padding">
        <h2 className="text-base font-semibold text-gray-700 mb-1 mt-2">Upcoming Payments</h2>
        <p className="text-2xl font-bold text-gray-800 mb-1 mt-3">{formatCurrency(upcomingPayments)}</p>
        <p className="text-xs text-gray-500">Next payment in {nextPaymentDays} days</p>
      </Card>
    </>
  );
};

export default PaymentSummary;